import React from 'react';
import { Resizable } from 'react-resizable';

// Header cell for resizable columns
interface ResizableTitleProps {
    onResize?: (
        e: React.SyntheticEvent<HTMLTableCellElement>,
        data: { size: { width: number } },
    ) => void;
    width?: number;
    minWidth?: number;
    children?: React.ReactNode;
    [key: string]: any;
}

const ResizableTitle: React.FC<ResizableTitleProps> = ({
    onResize,
    width,
    minWidth,
    children,
    ...restProps
}) => {
    if (!width) {
        return <th {...restProps}>{children}</th>;
    }

    return (
        <Resizable
            width={width}
            height={0}
            minConstraints={[minWidth || 50, 0]}
            maxConstraints={[800, 0]}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={e => {
                        e.stopPropagation();
                    }}
                />
            }
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th
                {...restProps}
                title={typeof children === 'string' ? children : undefined}
            >
                {children}
            </th>
        </Resizable>
    );
};

export default ResizableTitle;
